import DateInput from "@/components/DateInput";
import { useTranslation } from "@/i18n/client";
import dayjs from "dayjs";
import { DateInputProps } from "@mantine/dates";

const defaultDate = new Date(new Date().getFullYear() - 50, 0, 1);

export const BirthDate = (props: DateInputProps) => {
  const { t } = useTranslation(["customer", "hints"]);

  return (
    <DateInput
      label={t("customer:birthDate")}
      defaultDate={defaultDate}
      maxDate={dayjs().subtract(18, "years").toDate()}
      minDate={dayjs().subtract(120, "years").toDate()}
      {...props}
      value={props.value ?? undefined}
    />
  );
};
